var map = {
	"./archive.svg": 858,
	"./arrow-bottom.svg": 859,
	"./arrow-extreme.svg": 860,
	"./arrow-left.svg": 861,
	"./arrow-login.svg": 862,
	"./arrow-solid-bottom.svg": 863,
	"./arrow.svg": 864,
	"./arrow_table.svg": 865,
	"./attention.svg": 866,
	"./b.svg": 867,
	"./back.svg": 868,
	"./beef.svg": 869,
	"./bill.svg": 870,
	"./biochemical.svg": 871,
	"./blank.svg": 872,
	"./calendar.svg": 873,
	"./carrot.svg": 874,
	"./check.svg": 875,
	"./circle.svg": 876,
	"./clock.svg": 877,
	"./cloud.svg": 878,
	"./copy-down.svg": 879,
	"./copy-up.svg": 880,
	"./copy.svg": 881,
	"./cross.svg": 882,
	"./dd_logo-short.svg": 883,
	"./dd_logo.svg": 884,
	"./dd_logo_small.svg": 885,
	"./dd_logo_white.svg": 886,
	"./del.svg": 887,
	"./double-arrow-down.svg": 888,
	"./edit.svg": 889,
	"./error.svg": 890,
	"./eye-crossed.svg": 891,
	"./eye.svg": 892,
	"./fish.svg": 893,
	"./fruit.svg": 894,
	"./genetic.svg": 895,
	"./graph.svg": 896,
	"./i.svg": 897,
	"./icon_arrow_small_l.svg": 898,
	"./icon_info.svg": 899,
	"./infinity.svg": 900,
	"./info.svg": 901,
	"./lens.svg": 902,
	"./list.svg": 903,
	"./list_o.svg": 904,
	"./list_u.svg": 905,
	"./logo-short.svg": 906,
	"./logo.svg": 907,
	"./logo_small.svg": 908,
	"./logo_white.svg": 909,
	"./logout.svg": 910,
	"./microelements.svg": 911,
	"./minus.svg": 912,
	"./moon.svg": 913,
	"./normweight.svg": 914,
	"./patient-card.svg": 915,
	"./payment_maestro.svg": 916,
	"./payment_mastercard.svg": 917,
	"./payment_mir.svg": 918,
	"./payment_visa.svg": 919,
	"./pdf.svg": 920,
	"./person.svg": 921,
	"./photo.svg": 922,
	"./plus.svg": 923,
	"./printer.svg": 924,
	"./qa.svg": 925,
	"./question.svg": 926,
	"./recovery.svg": 927,
	"./refresh.svg": 928,
	"./restore.svg": 929,
	"./revert.svg": 930,
	"./right_arrow.svg": 931,
	"./rouble.svg": 932,
	"./save.svg": 933,
	"./search.svg": 934,
	"./signup.svg": 935,
	"./soup.svg": 936,
	"./sun.svg": 937,
	"./sun_full.svg": 938,
	"./sun_rising.svg": 939,
	"./supplement.svg": 940,
	"./thinCross.svg": 941,
	"./thinTick.svg": 942,
	"./tick.svg": 943,
	"./time.svg": 944,
	"./trueArrow.svg": 945,
	"./universal.svg": 946,
	"./urine.svg": 947,
	"./v.svg": 948,
	"./vitamins.svg": 949,
	"./welcome_abort.svg": 950,
	"./welcome_ration.svg": 951,
	"./welcome_schedule.svg": 952,
	"./welcome_time.svg": 953,
	"./welcome_trust.svg": 954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 857;